import React, { useState } from 'react';
import './List.scss'
import { useHistory } from 'react-router-dom';
import Button from '../button/Button';
import { assignManager } from '../../utils/apis/services/api';
import NotFound from '../../components/lottie/lottie';
import request from '../../assets/images/panel/request.png'
import ContentLoader from "react-content-loader"
import translate from "../../utils/locale/language"
import driverfill from '../../assets/images/panel/driverfill.svg'
import adminfill from '../../assets/images/panel/adminfill.svg'
import serverfill from '../../assets/images/panel/server-fill.png'
import { toast } from 'react-toastify';

const List = ({ data, onClick, isClose, id, getDetails, from, status, disableDetailNav }) => {

  const history = useHistory();
  const [showshimmer,setShimmer]=useState(true)
  const backToEnquiryDetails = async (managerId) => {
    let result = await assignManager(id, managerId);
    if(result.data.ResponseCode===200&&result.data.ErrorCode===null)
    {
      toast.success("Manager Assigned Succesfully")
    }
    isClose()
    from === "drivers" ? history.push({ pathname: "/drivers/details", state: { "driverId": id } }) : history.push({ pathname: "/enquiry/details", state: { "driverId": id } })
    // await  getDriverDetails(id) 
    getDetails(id)
  }
  let shimmer = <ContentLoader
            speed={2}
            width={75}
            height={75}
            // viewBox="0 0 1200 760"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
            // {...props}
          >
            <circle cx="35" cy="35" r="25" />
          </ContentLoader> 

const capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

  return (
   <div>{from==="payments"? 
   <table className='list-container'>
      <thead className='table-head'>
        <tr className='head-row'>
          <th width={"20%"} style={{ paddingLeft: '2%' }}>{translate("sender")}</th>
          {/* <th width={"20%"} >{translate("recipient")}</th> */}
          <th width={"20%"} >{translate("transaction_id")}</th>
          <th width={"20%"} style={{ paddingLeft: '2%' }}>{translate('tmode')}</th>
          <th width={"20%"} style={{ paddingLeft: '2%' }}>{translate('amount')}</th>
          <th width="20%">{translate('status')}</th>      
         </tr>
      </thead>
      <tbody>{data.length > 0 && data ? data.map((item, index) => (<tr key={index} className='body-row'>
        <td style={{ paddingLeft: '2%' }}>{/* className="col-1" style={{ paddingLeft: '7%' }}*/}
          {/* {showshimmer ? shimmer:''} */}
          {/* <img className={showshimmer ?'partner-img':'payment-img'} src={item.sender?(item.sender.role===1?adminfill:driverfill):serverfill} onLoad={()=>setShimmer(false)} alt='' /> */}
          <div>
            <p className='request-name' >{(item.sender?item.sender.full_name:"2C2P")}</p>
          </div>
        </td>
        <td >
          <div style={{display:"flex"}}>
            <p>{item.transaction_id}</p>
          {/* <img className={showshimmer ?'payment-img':'payment-img'} src={item.receiver?(item.receiver.role===1?adminfill:driverfill):serverfill} onLoad={()=>setShimmer(false)} alt='' /> */}
            {/* <p className='request-name' >{(item.receiver?item.receiver.full_name:"2C2P")}</p> */}
          </div>
        </td>
        <td style={{ paddingLeft: '3%' }}>{capitalize(item.type)}</td>
        <td style={{ paddingLeft: '3%' }}>{item.currency + " " + item.amount}</td>
       <td>{capitalize(item.status)}</td>
        {/* <td>{props.children}</td> */}
        {item.role === "Manager" && from !== "admin" ?
          // <td><Button  onClick={() =>   history.push({pathname: "/enquiry/details",state: { "mangerId":item.id }})}
          <td><Button id={"test"} onClick={() => backToEnquiryDetails(item.id)}
            style={{ backgroundColor: '#ffffff', color: "#03A8EE", border: '1px solid #03A8EE', height: 40, width: 95 }}
          title="Assign" /></td>: ''}</tr>
      )) : <td><NotFound /></td>
      }
      </tbody>
    </table>:
    from==="products"? 
    <table className='list-container'>
       <thead className='table-head'>
         <tr className='head-row'>
           <th width={"25%"} style={{ paddingLeft: '5.5%' }}>{translate("name")}</th>
           <th width={"25%"} >{translate("brand")}</th>
           <th width={"25%"} >{translate('status')}</th>
           <th width={"25%"} >{translate('amount')}</th>
          </tr>
       </thead>
       <tbody>{data.length > 0 && data ? data.map((item, index) => (<tr key={index} onClick={()=> { if (disableDetailNav) return; history.push({ pathname: "/products/details", state: {"productId": item.id} }); }} className='body-row'>
        <td className="col-1" style={{ paddingLeft: '7%' }}>
           {showshimmer ? shimmer:''}
          <img
            className={showshimmer ?'partner-img':'payment-img'}
            src={
              (item.images && typeof item.images === "object"
                ? (item.images.profile_image_url || item.images.image_url || item.images.url)
                : "") ||
              (Array.isArray(item.images) ? (item.images[0]?.image_url || item.images[0]?.url) : "") ||
              request
            }
            onLoad={()=>setShimmer(false)}
            alt=''
          />
           <div>
             <p className='request-name' >{(item.title?item.title:'')}</p>
           </div>
         </td>
         <td >{(item.subtitle?item.subtitle:'')}</td>
         <td >{"Active"}</td>
         <td >{`${item.preferred_currency || "₭"} ${item.price ?? 0}`}</td>
        <td>{capitalize(item.status)}</td>
         {/* <td>{props.children}</td> */}
         {item.role === "Manager" && from !== "admin" ?
           // <td><Button  onClick={() =>   history.push({pathname: "/enquiry/details",state: { "mangerId":item.id }})}
           <td><Button id={"test"} onClick={() => backToEnquiryDetails(item.id)}
             style={{ backgroundColor: '#ffffff', color: "#03A8EE", border: '1px solid #03A8EE', height: 40, width: 95 }}
           title="Assign" /></td>: ''}</tr>
       )) : <td><NotFound /></td>
       }
       </tbody>
    </table>:
    from==="users"?
    <table className='list-container p-2'>
      <thead className='table-head'>
        <tr className='head-row'>
          <th width={"32%"} style={{ paddingLeft: '7%' }}>{translate("name")}</th>
          <th width={"20%"}>{translate("phone")}</th>
          <th width={"34%"}>{translate("email")}</th>
          <th width={"14%"}>{translate("status")}</th>
        </tr>
      </thead>
      <tbody>{data.length > 0 && data ? data.map((item, index) => (<tr key={index} className='body-row'>
        <td style={{ paddingLeft: '2%' }} className="col-1">
          <img
            className={showshimmer ?'partner-img':'shimmer-img'}
            src={item.profile_image ? item.profile_image : request}
            onLoad={()=>setShimmer(false)}
            alt=''
          />
          <div style={{width:"18vw"}}>
            <p className='request-name name-crop'>{item.full_name || "-"}</p>
          </div>
        </td>
        <td>{item.phone_number || "-"}</td>
        <td>{item.email || "-"}</td>
        <td>{item.is_active ? "Active" : "Inactive"}</td>
      </tr>)) : <td><NotFound /></td>
      }
      </tbody>
    </table>:

    <table className='list-container p-2'>
      <thead className='table-head'>
        <tr className='head-row'>
          {from === "orders" ? <th width={"15%"} style={{ paddingLeft: '2%' }}>{translate('order_id')}</th>: ""  }
          <th style={{ paddingLeft: '2%' }} width={from === "admin" ? "25%" :"15%"} >{  translate("name")}</th>{/*style={{ paddingLeft: '7%' }}*/}
          <th width={from === "admin" ? "25%" :"37%"} >{ from === "orders" ? translate('useremail'): translate("phone")}</th>
          <th width={from === "admin" ? "25%" :"18%"}>{ from === "orders" ? translate('status'): translate("email")}</th>
          <th width={"21%"}>{ from === "orders" ? translate('amount'): translate("status")}</th>
         </tr>
      </thead>
      <tbody>{data.length > 0 && data ? data.map((item, index) => (<tr key={index} className='body-row' onClick={() => {
        if (from === 'admin' && disableDetailNav) return;
        if (from === 'enquiry') history.push({ pathname: "/enquiry/details", state: { "driverId": item.id, "status": status } });
        else if (from === 'admin') history.push({ pathname: "/superadmin/details", state: { "adminId": item.id, "role": item.role } });
        else if (from === 'orders') history.push({ pathname: "/orders/details", state: {"OrderId": item.order_id} });
        else history.push({ pathname: "/drivers/details", state: { "driverId": item.id, "status": status } });
      }}>
      {from === "orders" ? <td style={{ paddingLeft: '2%' }}>{item.order_id}</td>: ""}
        <td style={{ paddingLeft: '2%' }}>{/* className="col-1"*/}
          {/* {showshimmer ? shimmer:''} */}
          {/* <img className={showshimmer ?'partner-img':'shimmer-img'} src={item.profile_image_url&&!showshimmer ?item.profile_image_url :from==="orders"&&!showshimmer&&item.driver_details.driver_profile_image_url ?item.driver_details.driver_profile_image_url:request} onLoad={()=>setShimmer(false)} alt='' /> */}
          <div >{/*style={{width:"18vw"}}*/}
            <p className='request-name name-crop' >{from==="orders" ?item.driver_details.driver_full_name: item.full_name}</p>
            <p className='request-address'>{from==="orders" ?"":item.address}</p>
          </div>
        </td>
        <td>{from==="orders" ?item.user_email:item.phone_number}</td>
        <td>{from==="orders" ?item.status:(item.email||'').split('_')[0]}</td>
        {/* convert email name from neeraj.rawat+50@rootinfosol.com_rejected_20260213063127 to neeraj.rawat+50@rootinfosol.com */}
        {/* 2026-02-13T05:54:23.633779Z to 2026-02-13 */}
        <td>{from==="orders" ?item.preferred_currency+" "+item.total_amount:(from==="admin" ? (item.is_active ? "Active" : "Inactive") : (from==="driver" && typeof item.is_approved==="boolean" ? (item.is_approved ? "Approved" : "Not Approved") : (item.driver_create_on||'').split('T')[0]))}</td>
        {/* <td>{props.children}</td> */}
        {item.role === "Manager" && from !== "admin" ?
          // <td><Button  onClick={() =>   history.push({pathname: "/enquiry/details",state: { "mangerId":item.id }})}
          <td><Button id={"test"} onClick={() => backToEnquiryDetails(item.id)}
            style={{ backgroundColor: '#ffffff', color: "#03A8EE", border: '1px solid #03A8EE', height: 40, width: 95 }}
          title="Assign" /></td>: ''}</tr>
      )) : <td><NotFound /></td>
      }
      </tbody>
    </table>
}
</div>
  )
}

export default List
